import styled from 'styled-components';

import { H5 } from "../../typography";

/* ----------------------------- StyledErrorTitle ----------------------------- */

export const StyledErrorTitle = styled(H5)(
    ({ theme }) => `
        color: ${theme.sections.negative};
        font-size: 1rem;
        line-height: 130%;
        padding: 1rem 0 0 0;
        margin: 0;
    `,
);
